import { useContext, useEffect, useLayoutEffect } from "react";
import { useState } from "react";
import { RemoveAllCookies } from "../../JS/Common";
import Cookies from "js-cookie";
import { LazyLoadImage } from "react-lazy-load-image-component";
import CustomSVG from "../../Components/CustomSVG";
import useConfig from "../../Hooks/useConfig";

export function Logout() {
    const {primary_text} = useConfig();
    var loadtesting = Cookies.get('isloadtesting');
    useEffect(() => {
        RemoveAllCookies();
    }, [])
    const [count, setCount] = useState(5);
    useLayoutEffect(() => {
        const timer = setTimeout(() => {
            if (count > 0) {
                setCount(count - 1);
            } else {
                if (loadtesting == 1) {
                    window.location.href = '/loadtestinglogin'
                } else {
                    window.location.href = '/'
                }
            }
        }, 1000);
        return () => clearTimeout(timer);
    }, [count]);
    return (
        <>
            <LazyLoadImage src="/images/LoginBg.png" alt="" className="MainDiv-bg-image" />
            <div className="position-relative MainDiv">
                <div className="card mx-auto">
                    <div className="p-4 row">
                        <p>Redirecting to login page in {count} seconds...</p>
                        <div className="col-md-4 offset-md-4">
                            <CustomSVG src='/images/LogOutImage.svg' stroke="var(--primary-color)" height='90px' />
                        </div>
                        <div className="pt-4" style={{ color: '#495057' }}><h4>You are Logged Out</h4></div>
                        <div className="pt-2" style={{ color: '#878a99' }}><h6>Thank you for using {primary_text} </h6></div>
                        <div className='text-center pt-3'>
                            <button className='SaveBtn' onClick={() => loadtesting == 1 ? window.location.href = '/loadtestinglogin' : window.location.href = '/'} style={{ width: '90%' }}>Sign In</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
